import { actions } from 'actions';
import { createUniqueStr } from 'helpers';

const initialState = {
  status: null,
  items: [],
};

/**
 * プログラムファイルの情報を管理する
*/
const programFileReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.UPLOAD_PROGRAM_FILE: {
      state.status = createUniqueStr();
      const data = {
        key: action.key,
        size: action.size,
        lastModified: action.lastModified
      };
      // プログラムファイルの更新の場合
      if (action.isUpdate) {
        return {
          status: createUniqueStr(),
          items: [ 
            ...state.items.filter(item => item.key !== action.key), 
            {...data}
          ]
        };  
      // プログラムファイルの新規アップロードの場合
      } else {
        return {
          status: createUniqueStr(),
          items: [...state.items, {...data}]
        };
      }
    }
    case actions.DELETE_PROGRAM_FILE:
      return {
        status: createUniqueStr(),
        items: state.items.filter(state => state.key !== action.key)
      };
    case actions.FETCH_PROGRAM_FILES:
      return {
        status: createUniqueStr(),
        items: [...action.items]
      };
    default:
      return state;
  }
};

export default programFileReducer;